export default __webpack_public_path__ + "static/media/onboarding_guide_1.56195cb6.png";